import React, { useEffect, useCallback, useState} from 'react';
import {effectOptions, getEffectOption, initializeEffect} from 'components/effects/constants.js';
import EffectComponent from "components/effects/EffectComponent.js"
import Dropdown from 'react-dropdown';
import {connect} from 'react-redux';

const EffectChooser = ({effect, sequencerEngine, track, onChange, onDelete}) => { 
    let fxComponent = '';
    if (effect) {
        fxComponent = (
            <EffectComponent
              sequencerEngine={sequencerEngine}
              track={track}
              compact={true}
              instrument={true}
              onDeleteEffect={onDelete}
              effect={effect}
              send={undefined}/>);
    }

    const onChoose = useCallback((e) => {
        let effect = initializeEffect(e.value, sequencerEngine);
        effect.enable(true);
        if (effect.wetParameter) {
            effect.wetParameter.set(1);
        }
        onChange(effect);
    }, [onChange, sequencerEngine]);

    return (
        <div>
          <Dropdown
            className='send-effects-dropdown'
            options={effectOptions}
            onChange={onChoose}
            option={effect && effectOptions.find(x => x.label === effect.name)}
            placeholder="Audio FX" />
          {fxComponent}
        </div>);
}

const mapStateToProps = (state, props) => {
  return {
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(EffectChooser);
